export default __webpack_public_path__ + "static/media/distance.240eff8f.svg";